import React from 'react'
import _ from "underscore";

// Colour, Colour, colour, colour
const Colour = (props) => {
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);
    
    if (childBlocks.length > 0) {
        return (
            <category id="colour" name="Color" colour="%{BKY_COLOUR_HUE}" iconclass="category with-icon-paths snap-icon-theme_dual">
                <label text="Color"></label>
                { childBlocks }
            </category>
        );
    }

    return null;
};

export default Colour